<!--
  WCAG 2.1 AA — 4.1.3 Status Messages.

  Responsibilities are split across two elements to avoid two subtle UX
  issues flagged in code review:

    1. The outer <div aria-live="polite"> is ALWAYS in the DOM. Screen
       readers must observe the live region before content is inserted
       for announcements to fire reliably — hence the always-present
       wrapper (no role, no aria-label, so it isn't a landmark).

    2. The inner <section aria-label="System messages">
       is only rendered when there is actual content. This prevents an
       empty landmark from cluttering screen-reader landmark navigation
       (NVDA D key, VoiceOver rotor, JAWS R key) and prevents NVDA +
       Firefox from prepending the region label to every announcement.

  All existing visual behavior (card layout, spacing) is preserved.
-->
<div aria-live="polite" aria-atomic="false">
  @if (systemMessages.data$.value.length) {
    <section aria-label="System messages">
      @for (message of systemMessages.data$.value; track (message.titleCode || $index)) {
        <nsc-card [error]="true" [className]="message.className">
          <nsc-card-title-error title="{{message.titleDescription}}" [className]="message.className"
            icon="{{message.icon}}">
            <div>
              <span [innerHtml]="message.message | safeHtml:'html'"></span>
            </div>
          </nsc-card-title-error>
        </nsc-card>
        <nsc-spacer size="xs"></nsc-spacer>
      }
      <nsc-spacer size="xs"></nsc-spacer>
      <nsc-spacer size="xs"></nsc-spacer>
    </section>
  }
</div>